import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { printCSS } from '@utils/style'

interface LayoutCardProps {
  className?: string
  children?: ReactNode
}

const StyledLayoutCardWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
      colors: { strokeWeak },
    },
  }) => css`
    border-radius: ${spacing8};
    border: 1px solid ${strokeWeak};
    height: max-content;
    overflow: hidden;
    ${printCSS(css`
      border: none;
    `)}
  `}
`

const LayoutCard: FunctionComponent<LayoutCardProps> = ({
  className,
  children,
}) => (
  <StyledLayoutCardWrapper className={className}>
    {children}
  </StyledLayoutCardWrapper>
)

export default LayoutCard
